var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.selected_menu)?_c('HeadBanner',{attrs:{"itemData":_vm.$store.state.selected_menu}}):_vm._e(),_c('Breadcrumb'),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.MemberTabsContent.conf.enabled'
      ) == 1
    )?_c('MemberTabsContentInvestors',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.MemberTabsContent.data'
      ),"itemConf":_vm._.get(
        this.$store.state.current_content,
        'secondary.MemberTabsContent.conf'
      ),"tabsData":_vm._.get(this.$store.state.indx, 'terms.investors_management_category')}}):_vm._e(),_c('intersect',{on:{"enter":function($event){_vm.animate = true}}},[_c('section',{staticClass:"container layout-outer flex-box"},[_c('div',{staticClass:"layout-left"},[(
            _vm._.get(
              this.$store.state.current_content,
              'secondary.DropdownList.conf.enabled'
            ) == 1
          )?_c('DownloadList',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.DropdownList.data.0.smarttabs')}}):_vm._e()],1)])]),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.NewsAndMedia.conf.enabled'
      ) == 1
    )?_c('NewsAndMedia',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.NewsAndMedia')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.Partners.conf.enabled'
      ) == 1
    )?_c('Partners',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.Partners')}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }